import { APP_PERMISSIONS } from '@exam-management/permissions';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QContentQuestionUsageLayout() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW,
        APP_PERMISSIONS.EXAM.QSET.VIEW,
      ]}
    >
      <Outlet />
    </PermissionGuard>
  );
}
